export var ExprCall;
(function (ExprCall) {
    let Name;
    (function (Name) {
        Name["Any"] = "ANY";
        Name["Agg"] = "AGG";
        Name["Avg"] = "AVG";
        Name["Count"] = "COUNT";
        Name["CountD"] = "COUNTD";
        Name["CountDA"] = "COUNTDA";
        Name["Median"] = "MEDIAN";
        Name["Min"] = "MIN";
        Name["Max"] = "MAX";
        Name["StDev"] = "STDEV";
        Name["StDevP"] = "STDEVP";
        Name["Sum"] = "SUM";
        Name["Var"] = "VAR";
        Name["VarP"] = "VARP";
    })(Name = ExprCall.Name || (ExprCall.Name = {}));
    (function (Name) {
        function make(name) {
            switch (name.toUpperCase()) {
                case Name.Avg:
                    return Name.Avg;
                case Name.Count:
                    return Name.Count;
                case Name.CountD:
                    return Name.CountD;
                case Name.CountDA:
                    return Name.CountDA;
                case Name.Max:
                    return Name.Max;
                case Name.Median:
                    return Name.Median;
                case Name.Min:
                    return Name.Min;
                case Name.StDev:
                    return Name.StDev;
                case Name.StDevP:
                    return Name.StDevP;
                case Name.Sum:
                    return Name.Sum;
                case Name.Var:
                    return Name.Var;
                case Name.VarP:
                    return Name.VarP;
                default:
                    return Name.Any;
            }
        }
        Name.make = make;
        function isKnown(name) {
            return Name.make(name) !== Name.Any;
        }
        Name.isKnown = isKnown;
    })(Name = ExprCall.Name || (ExprCall.Name = {}));
})(ExprCall || (ExprCall = {}));
